import { capitalizeFirstLetter } from "./capitalizeFirstLetter";

export default function getMediaSectionName(section, contentType) {
    return `${capitalizeFirstLetter(section)} ${capitalizeFirstLetter(contentType)}s`;
}